
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import CTASection from './components/CTASection';

const ParticuliersPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <ServicesGrid />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ParticuliersPage;
